import {FunctionComponent, useEffect, useState} from "react";
import {
    Box,
    Card,
    Tab,
    Tabs,
    Typography
} from "@mui/material";
import {UserList} from "../common/UserList";
import bgcService, {IBgcUser} from "../../services/bgcService";

export const BgcReviewList: FunctionComponent = () => {
    const [tab, setTab] = useState(0);
    const [newUsers, setNewUsers] = useState<IBgcUser[]>([]);
    const [waitingUsers, setWaitingUsers] = useState<IBgcUser[]>([]);

    useEffect(() => {
        void bgcService.getNewBgcReviews().then(setNewUsers);
        void bgcService.getWaitingWindowBgcReviews().then(setWaitingUsers);
    }, []);

    return (
        <Box>
            <Typography variant={'h1'} sx={{mb: 4}}>
                Review BGC
            </Typography>

            <Tabs value={tab} onChange={(_, newVal) => setTab(newVal)} sx={{mb: 2}}>
                <Tab label="New"/>
                <Tab label="Waiting Window"/>
            </Tabs>

            {tab === 0 && (
                <Card style={{marginBottom: 30}}>
                    <UserList users={newUsers} showName={false} showLoginTime={true} showCandidateId={true} to={"users"}/>
                </Card>
            )}

            {tab === 1 && (
                <Card style={{marginBottom: 30}}>
                    <UserList users={waitingUsers} showName={false} showLoginTime={true} showCandidateId={true} showAdverseActionDate={true} to={"users"}/>
                </Card>
            )}
        </Box>
    );
};
